package uk.co.nickthecoder.kyd

import uk.co.nickthecoder.glok.property.Property

actual fun findCustomisableProperties(obj: Customisable): List<Property<*>> {
    return emptyList()
}
